import * as React from 'react';
import { Col } from 'reactstrap';
import { IGlobalContextProps, withGlobalContext } from 'src/context/global.context';
import { IProject, IProposition } from 'src/model';
import { ProjectNavLinkWithRouter } from './ProjectNavLink';

interface IProjectNavProps {
  pathname: string;
  project: IProject | null;
  proposition: IProposition | null;
}

const ProjectNav: React.SFC<IProjectNavProps & IGlobalContextProps> = ({
  context,
  pathname,
  project,
  proposition,
}) => {
  const isActive = (currentPathname: string) => {
    return currentPathname === pathname;
  };
  const { user } = context;
  const isConsultant = !!(user && user.type === 'consultant');
  const isRefused = !!(proposition && (proposition.meta.status === 'refused' || proposition.meta.status === 'rejected'));
  const isAccepeted = !!( proposition && proposition.meta.status === 'accepted');

  return (
    <Col
      md='2'
      className='d-flex flex-column align-items-center p-3 border border-top-0 border-bottom-0 border-left-0'
      style={{ fontFamily: 'Fredoka One', fontSize: '16px' }}
    >
      <ProjectNavLinkWithRouter
        isActive={isActive('')}
        label='Fiche projet'
        pathname=''
        src='document'
      />
      {user && user.type === 'client' ? (
        <ProjectNavLinkWithRouter
          isActive={isActive('consultants')}
          isDisabled={
             !!!project || (project && !!!project.propositionList.length ) || (project.proposition && project.proposition.meta.status==='hidden')
          }
          label='Consultants experts'
          pathname='consultants'
          src='team-skills'
        />
      ) : (
        <ProjectNavLinkWithRouter
          isActive={isActive('proposition')}
          isDisabled={!!proposition && proposition.meta.status === 'hidden'}
          label='Ma proposition'
          pathname='proposition'
          src='new'
        />
      )}
      <ProjectNavLinkWithRouter
        isActive={isActive('workspace')}
        isDisabled={
          !!!project ||
          (project && !!!project.proposition) ||
          (isConsultant && !isAccepeted)
        }
        label='Workspace'
        pathname='workspace'
        src='experience-2'
      />
      <ProjectNavLinkWithRouter
        isActive={isActive('evaluation')}
        isDisabled={
          !!!project ||
          (project && project.meta.status !== 'ended') ||
          (isConsultant && isRefused)
        }
        label='Clôture / Evaluation'
        pathname='evaluation'
        src='experience'
      />
    </Col>
  );
};

export const ProjectNavWithGlobalContext = withGlobalContext(ProjectNav);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectNav/ProjectNav.tsx